import { React, useEffect, useState } from "react";
import {
  Button,
  Container,
  Grid,
  GridColumn,
  GridRow,
  Header,
  Image,
} from "semantic-ui-react";
import Gallery from "./gallery";
import CommonProjects from "./commonProjects";

export default function LandingPage(props) {
  const { setSelection } = props;
  const [b1Hovered, setB1Hovered] = useState(false);

  useEffect(() => {
    document.title = "Custom Metalwork & Fabrication | Launceston, Tasmania | Custom Metal Tas"; // Updated title
  }, []);

  const h1Style = {
    fontFamily: "'B612', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(3em, 4vw, 4em)",
  };

  const h2Style = {
    ...h1Style,
    fontSize: "clamp(2.7em, 3.5vw, 3.7em)",
    lineHeight: "clamp(1.1em, 1.1vw, 1.3em)",
    padding: "0em 0em 0.5em 0em",
  };

  const pStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    fontSize: "clamp(1.1em, 1vw, 1.4em)",
    lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  };

  const buttonStyle = {
    color: "#FFFFFF",
    fontSize: "1em",
    backgroundColor: "transparent",
    border: "solid 0.1em #FFFFFF",
    borderRadius: "3em",
    padding: "0.6em 3em 0.6em 3em",
    transition: "padding 1s ease",
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
  };

  const buttonStyleHover = {
    ...buttonStyle,
    padding: "0.6em 3em 0.6em 4em",
    transition: "padding 1s ease",
  };

  function PageSelectContactUs() {
    setSelection("contactUs");
    window.scrollTo(0, 0);
  }

  return (
    <main>
      <Grid>
        <GridRow
          style={{
            position: "relative",
            width: "100vw",
            overflow: "hidden",
            margin: "-7em 0em 0em 0em",
            height: "100vh",
            backgroundImage: "url('./customMetalHeaderBackground.webp')",
            alt: "Metal hexagon mesh",
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
          }}
          aria-label="Header section with background image"
        >
          <GridColumn
            verticalAlign="middle"
            style={{
              padding: "0em 10% 0em 10%",
              maxWidth: "100em",
              textAlign: "left",
            }}
          >
            <Header
              as="h1"
              content="Quality Custom Metal Fabrication Solutions, Built to Last"
              aria-label="Main heading: Quality Custom Metal Fabrication Solutions, Built to Last"
              style={h1Style}
            />
            <Button
              content="Receive a free quote"
              aria-label="Navigate to Contact Page"
              onClick={PageSelectContactUs}
              onMouseEnter={() => setB1Hovered(true)}
              onMouseLeave={() => setB1Hovered(false)}
              style={b1Hovered ? buttonStyleHover : buttonStyle}
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid stackable style={{ padding: "10em 5% 10em 5%" }}>
        <GridRow>
          <GridColumn
            verticalAlign="middle"
            textAlign="Left"
            width={10}
            style={{ padding: "0em 5em 0em 0em" }}
          >
            <Container>
              <Header
                as="h2"
                content="Expert Metal Fabrication & Welding Services in Tasmania"
                aria-label="Section heading: Expert Metal Fabrication & Welding Services in Tasmania"
                style={h2Style}
              />
            </Container>
            <Container style={pStyle} aria-label="Description of metal fabrication & welding services">
              Custom Metal delivers high-quality metal fabrication and repair services
              across Tasmania, specializing in aluminum, stainless steel, steel, and more.
              Whether you need custom gates, structural steelwork, or boat modifications,
              we provide expert craftsmanship with a focus on durability and precision.
            </Container>
          </GridColumn>
          <GridColumn width={6}>
            <Image
              src="./personWelding.webp"
              alt="Professional welder performing welding & metal fabrication"
              fluid
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./topBreak.svg" alt="Decorative top break" />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid style={{ padding: "10em 5% 10em 5%", backgroundColor: "#212121" }}>
        <GridRow>
          <GridColumn textAlign="Left">
            <Gallery aria-label="Gallery of past metalwork projects" />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./bottomBreak.svg" alt="Decorative bottom break" />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid container doubling stackable style={{ padding: "10em 5% 10em 5%" }}>
        <GridRow>
          <GridColumn textAlign="Left" style={{ padding: "0em 5em 0em 0em" }}>
            <Container>
              <Header 
                as="h2" 
                content="Explore Our Common Metalwork Projects" 
                aria-label="Section heading: Explore Our Common Metalwork & Welding Projects"
                style={h2Style} />
            </Container>
          </GridColumn>
        </GridRow>

        <GridRow columns={1}>
          <GridColumn style={{ padding: "0em 0em 0em 0em" }}>
            <CommonProjects aria-label="List of common metalwork projects" />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow style={{ padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image src="./topBreak.svg" alt="Decorative top break" />
          </GridColumn>
        </GridRow>
      </Grid>
    </main>
  );
}